module.exports = {
	"ha": "iha",
	"id": 5.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "65%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "65%",
				"height": "35%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 75.86206896551724,
						"dataLabels": {
							"enabled": true,
							"format": "22",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.06896551724138,
						"dataLabels": {
							"enabled": true,
							"format": "18",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.06896551724138,
						"dataLabels": {
							"enabled": true,
							"format": "18",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 48.275862068965516,
						"dataLabels": {
							"enabled": true,
							"format": "14",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 27.586206896551722,
						"dataLabels": {
							"enabled": true,
							"format": "8",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.50746268656717,
						"dataLabels": {
							"enabled": true,
							"format": "66",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 89.55223880597015,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.05970149253731,
						"dataLabels": {
							"enabled": true,
							"format": "59",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.64179104477611,
						"dataLabels": {
							"enabled": true,
							"format": "48",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.23880597014925,
						"dataLabels": {
							"enabled": true,
							"format": "35",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.4251968503937,
						"dataLabels": {
							"enabled": true,
							"format": "125",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.5511811023622,
						"dataLabels": {
							"enabled": true,
							"format": "115",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.5511811023622,
						"dataLabels": {
							"enabled": true,
							"format": "115",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.67716535433071,
						"dataLabels": {
							"enabled": true,
							"format": "105",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 47.24409448818898,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.39449541284404,
						"dataLabels": {
							"enabled": true,
							"format": "429",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.59633027522935,
						"dataLabels": {
							"enabled": true,
							"format": "395",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 89.6788990825688,
						"dataLabels": {
							"enabled": true,
							"format": "391",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.25688073394495,
						"dataLabels": {
							"enabled": true,
							"format": "363",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.3394495412844,
						"dataLabels": {
							"enabled": true,
							"format": "250",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -24.13793103448276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4925373134328401,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -1.6666666666666718,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.644067796610166,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -27.083333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.5748031496062964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6055045871559592,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.9254079254079235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -1.0126582278481067,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.161125319693095,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -31.129476584022044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=29"
			},
			{
				"x": 9,
				"text": "30–39<br>n=67"
			},
			{
				"x": 15,
				"text": "40–49<br>n=127"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=436"
			}
		],
		"dataTable": {
			"< 30": [
				29,
				22,
				18,
				18,
				14,
				8
			],
			"30–39": [
				67,
				66,
				60,
				59,
				48,
				35
			],
			"40–49": [
				127,
				125,
				115,
				115,
				105,
				60
			],
			"≥ 50": [
				436,
				429,
				395,
				391,
				363,
				250
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_3.json
// module id = 236
// module chunks = 0